module.exports = __webpack_public_path__ + "img/hotels.09b9ccb4.jpg";